import controller from './testimonies.controller';
import template1 from './testimonies.view-t1.html';

let TestimoniesComponent = {
    template: template1,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        type: '@',
        itemId: '@'
    }
};

export default TestimoniesComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/testimonies/testimonies.component.js
 **/